import api from "api";
import React, { useState, useEffect, ChangeEventHandler, HtmlHTMLAttributes, useCallback } from "react";
import "./account.scss";
import { useParams } from "react-router-dom";
import { AnyAsyncThunk } from "@reduxjs/toolkit/dist/matchers";

interface props {
  setStep3States: any;
  isTrail: boolean;
  sendAgreementNow: boolean;
}

function AccountManagement({ setStep3States, isTrail, sendAgreementNow }: props) {
  const params: any = useParams();

  const default_BillingType = 3;
  const default_CancellationType = 1;
  const default_PaymentType = 2;

  const PaymentTypes = [
    {
      Id: 1,
      Description: "Arrears",
    },
    {
      Id: 2,
      Description: "Event/Budget",
    },
  ];

  const selectItem = (value: any, state: any) => {
    if (state == "bequestedBy") {
      if (value.IsPrimary) {
        setStep3States(state, value.Id);
        return true;
      }
      return false;
    }
    if (state == "billingType") {
      if (value === default_BillingType) {
        setStep3States(state, value);
        return true;
      }
      return false;
    }
    if (state == "paymentType") {
      if (value === default_PaymentType) {
        setStep3States(state, value);
        return true;
      }
      return false;
    }
    if (state == "cancellationType") {
      if (value === default_CancellationType) {
        setStep3States(state, value);
        return true;
      }
      return false;
    }
  };

  const selectChange = (event: React.ChangeEvent<HTMLSelectElement>, state: string) => {
    setStep3States(state, event.target.value);
  };

  const [accountOptions, setAccountOptions] = useState<any>();

  const PopulateSelections = useCallback(async () => {
    api.account.PopulateOptions(params.clientId).then((data) => {
      setAccountOptions(data);
    });
  }, [params.clientId]);

  useEffect(() => {
    PopulateSelections();
  }, [PopulateSelections]);

  return (
    <div className="client-management AccountManagement">
      <div className="contact-us">
        <div className="input-group">
          <label>Requested By</label>
          <select defaultValue={0} onChange={(event: any) => selectChange(event, "bequestedBy")}>
            <option value={0} disabled>
              Select option...
            </option>
            {accountOptions?.RequestedBys.map((x: any, i: number) => (
              <option key={i} selected={x.IsPrimary} value={x.Id}>
                {x.Name}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group">
          <label>Billing Type</label>
          <select defaultValue={0} onChange={(event: any) => selectChange(event, "billingType")}>
            <option value={0} disabled>
              Select option...
            </option>
            {accountOptions?.BillingTypes.map((x: any, i: number) => (
              <option key={i} selected={selectItem(x.Id, "billingType")}>
                {x.Description}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
          <label>Payment Type</label>
          <select defaultValue={default_PaymentType} onChange={(event: any) => selectChange(event, "paymentType")}>
            <option value={0} disabled>
              Select option...
            </option>
            {PaymentTypes?.map((x: any, i: number) => (
              <option key={i} selected={selectItem(x.Id, "paymentType")}>
                {x.Description}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
          <label>Cancellation Type</label>
          <select defaultValue={0} onChange={(event: any) => selectChange(event, "cancellationType")}>
            {accountOptions?.CancellationTypes.map((x: any, i: number) => (
              <option key={i} selected={selectItem(x.Id, "cancellationType")}>
                {x.Description}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
          <label htmlFor="birthday">Start Date</label>
          <input type="date" id="birthday" name="birthday" onChange={(event: any) => selectChange(event, "agreementStartDate")} />
        </div>
        <div className="input-group">
          <label htmlFor="birthday">End Date</label>
          <input type="date" id="birthday" name="birthday" onChange={(event: any) => selectChange(event, "agreementEndDate")} />
        </div>
        <div className="input-group">
          <div style={{ width: "50px" }}>
            <label className="boxSelction">
              <h3>Trail</h3>
              <input type="checkbox" checked={isTrail} onChange={(event: any) => setStep3States("IsTrail", event.currentTarget.checked)} />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
        <div className="input-group">
          <div style={{ width: "188px" }}>
            <label className="boxSelction">
              <h3>Send agreement now</h3>
              <input type="checkbox" checked={sendAgreementNow} onChange={(event: any) => setStep3States("SendAgreementNow", event.currentTarget.checked)} />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountManagement;
